import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0f0f0f] py-10 px-6 mt-10 border-t border-gray-800 mb-16 h-full">
      <div className="max-w-4xl mx-auto text-center">
        <div className="flex items-center justify-center gap-2 mb-4">
          <img src="/ChaFreeBonusNow.png" alt="FreeBonusNow" className="h-16 w-auto" />
        <span className="text-gray-500 text-sm sm:text-base">FreeBonusNow</span>
        </div>
        <p className="text-gray-500 text-xs mb-8 leading-relaxed">
          All offers are provided by verified third-party partners. No hacks or cheats. 
          Rewards are subject to partner terms and conditions. <br className="hidden md:block" />
          Headquartered in <strong>New York, NY, USA</strong>. 
          © 2026 FreeBonusNow. All rights reserved.
        </p>
        <div className="flex justify-center gap-6 text-xs text-gray-400 font-medium">
          <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-white">Terms of Use</Link>
          <Link to="/support" className="hover:text-white">Support</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
